import type { SVGProps } from "react";

export function IconBlueStorefront(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M26 57V48C26 44.6863 28.6863 42 32 42C35.3137 42 38 44.6863 38 48V57M7 7H57V57H7V7Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.75 6.25H6.25V26H6.39404C7.12899 30.191 10.5976 33.42 14.835 33.42C18.9061 33.42 22.2676 30.4394 23.1769 26.4887C24.1443 30.4669 27.7293 33.42 32.005 33.42C36.2806 33.42 39.8657 30.4669 40.833 26.4887C41.7423 30.4394 45.1038 33.42 49.175 33.42C53.4123 33.42 56.881 30.191 57.6159 26H57.75V24.7763C57.7566 24.63 57.76 24.4829 57.76 24.335C57.76 24.1871 57.7566 24.04 57.75 23.8937V6.25Z"
        fill="#5486FA"
      />
      <path
        d="M7 17.5H57"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
